var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30373 12.6629L11.0068 19.5757C11.5503 20.1362 12.4497 20.1362 12.9932 19.5757L19.6963 12.6629C21.5 10.8027 21.3968 7.81616 19.4689 6.08496C17.5775 4.38663 14.6636 4.55918 12.9859 6.46884L12 7.59104L11.0141 6.46884C9.33644 4.55918 6.42246 4.38663 4.53114 6.08496C2.60321 7.81616 2.49996 10.8027 4.30373 12.6629Z",
    fill: "black"
  })));
};

export default SvgHeartFilled;